
import { countAd } from '@/http/api'
import { appWalletLink } from '@/const/hosts'
import {
  defineComponent,
  reactive,
  toRefs,
} from 'vue'
import { useStore } from 'vuex'
export default defineComponent({
  name: '',
  emits: ['toggleTmReceiveSuccessPopup'],
  props: {
    isShowTmReceiveSuccessPopup: {
      type: Boolean
    }
  },
  setup(props,{emit}) {
    const store = useStore()
    const data = reactive({
      browserEnv: store.state.browserEnv
    })
    const methods = {
      toggleTmReceiveSuccessPopup(isShowTmReceiveSuccessPopup: boolean) {
        emit('toggleTmReceiveSuccessPopup',{isShowTmReceiveSuccessPopup})
      },
      // 处理立即提现
      handleWidthDrawal() {
        countAd(6564)
        if (data.browserEnv === 1) { 
          window.location.href = 'pcautobrowser://more/?uri=' + appWalletLink
        } else {
          window.location.href = 'https://www1.pcauto.com.cn/zt/gz202012/openinstall/wap/wap-openinstall_channel.html?channelCode=256'
        }
      }
    }
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
